import { render, staticRenderFns } from "./BackToTop.vue?vue&type=template&id=04e08c16&scoped=true"
import script from "./BackToTop.vue?vue&type=script&lang=ts"
export * from "./BackToTop.vue?vue&type=script&lang=ts"
import style0 from "./BackToTop.vue?vue&type=style&index=0&id=04e08c16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04e08c16",
  null
  
)

export default component.exports